import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmail } from 'validator';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  constructor() {}

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (!email) {
        return null;
      }
      if (!isEmail(email)) {
        return { invalidEmail: 'Invalid email format as per RFC 5322.' };
      }
      return null;
    };
  }
}
